<template>
  <CChartBar
    :datasets="defaultDatasets"
    :labels="categories"
  />
</template>

<script>
import { CChartBar } from '@coreui/vue-chartjs'
import axios from "axios";

export default {
  name: 'CChartBarExample',
  components: { CChartBar },
  data () {
    return {
      result: [],
      progress: [],
      companyName: '',
      categories: [],
      progressPerCategory: ''
    }
  },
  computed: {
    defaultDatasets () {
      return [
        {
          label: this.companyName,
          backgroundColor: '#f87979',
          data: this.progress
        }
      ]
    }
  },
  mounted() {
    let self = this;
    const token = localStorage.getItem("api_token")
    axios.get(this.$apiAdress + '/api/progress/1', {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json'
      }
    }).then(function (response) {
      self.result = response.data.data
      console.log('result', self.result)
      self.getStat()
    }).catch(function (error) {
      console.log(error);
    });
  },
  methods: {
    getStat() {
      let self = this;
      for (let i = 0; i < self.result.length; i++) {
        self.companyName = self.result[i].company_id
        // self.progressPerCategory.push(self.result[i].progress_per_category)
        self.progressPerCategory = self.result[i].progress_per_category
      }
      for (let i = 0; i < self.progressPerCategory.length; i++) {
        self.progress.push(self.progressPerCategory[i].progress * 100)
        self.categories.push(self.progressPerCategory[i].category_id)
      }
      console.log(self.progressPerCategory)
    }
  }
}
</script>
